import { render, staticRenderFns } from "./MessageCba.vue?vue&type=template&id=d6057382&scoped=true"
import script from "./MessageCba.vue?vue&type=script&lang=js"
export * from "./MessageCba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6057382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6057382')) {
      api.createRecord('d6057382', component.options)
    } else {
      api.reload('d6057382', component.options)
    }
    module.hot.accept("./MessageCba.vue?vue&type=template&id=d6057382&scoped=true", function () {
      api.rerender('d6057382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Final/MessageCba.vue"
export default component.exports